import { CARD2, CARD3, BD, TX2, GR, BL } from "../../utils/constants";

export default function SubscriptionGate({
  title = "Trade Scanner Starter is required",
  subtitle = "Unlock market scans, ranked research candidates, risk/reward levels, signal tracking, backtests, and weekly scan history.",
  paymentUrl,
  onSubscribe,
  onActivateDemo,
  compact = false,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 760;
  const titleSize = isMobile ? 22 : compact ? 18 : 26;

  return (
    <div
      style={{
        background: "linear-gradient(180deg,rgba(13,23,40,0.96),rgba(10,16,32,0.96))",
        border: `1px solid ${GR}55`,
        borderRadius: 12,
        padding: compact ? "14px 16px" : isMobile ? "22px 16px" : "26px 28px",
        marginBottom: 14,
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", opacity: 0.26, background: "linear-gradient(rgba(56,189,248,.08) 1px,transparent 1px),linear-gradient(90deg,rgba(56,189,248,.08) 1px,transparent 1px)", backgroundSize: "30px 30px" }} />

      <div style={{ position: "relative", zIndex: 1, display: "grid", gridTemplateColumns: compact || isMobile ? "1fr" : "1.3fr 0.7fr", gap: 18, alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 8, color: GR, letterSpacing: 3, fontWeight: 800, marginBottom: 9 }}>
            PRO ACCESS
          </div>
          <div className="ts-gradient-text" style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: titleSize, lineHeight: 1.2, fontWeight: 900, marginBottom: 8, overflowWrap: "break-word", maxWidth: isMobile ? 300 : 620 }}>
            {title}
          </div>
          <div style={{ fontSize: 10, color: "#9fb2d3", lineHeight: 1.8, maxWidth: isMobile ? 300 : 620 }}>
            {subtitle}
          </div>
          <div style={{ display: "flex", gap: 7, flexWrap: "wrap", marginTop: 14 }}>
            {["Ranked signals", "Risk levels", "Backtests", "Digest"].map((item) => (
              <span key={item} style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 999, padding: "5px 9px", color: "#8ea2c0", fontSize: 8 }}>
                {item}
              </span>
            ))}
          </div>
        </div>

        <div style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 12, padding: isMobile ? 14 : 16, minWidth: 0 }}>
          <div style={{ fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>MONTHLY PLAN</div>
          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 30, fontWeight: 900, color: "#e4edff" }}>
            $9.99<span style={{ fontSize: 11, color: TX2, fontFamily: "'IBM Plex Mono',monospace" }}>/mo</span>
          </div>
          <div style={{ fontSize: 8, color: "#ffdf5f", lineHeight: 1.6, marginTop: 4 }}>
            Secure billing is handled through Stripe.
          </div>

          <button
            className="btn"
            onClick={onSubscribe}
            style={{
              width: "100%",
              marginTop: 13,
              background: `linear-gradient(135deg,${GR},${BL})`,
              borderRadius: 9,
              padding: "11px 12px",
              color: "#000",
              fontWeight: 900,
              fontSize: 10,
              letterSpacing: 1,
            }}
          >
            SUBSCRIBE MONTHLY
          </button>

          {onActivateDemo && (
            <button
              className="btn"
              onClick={onActivateDemo}
              style={{
                width: "100%",
                marginTop: 8,
                background: CARD3,
                border: `1px solid ${BD}`,
                borderRadius: 8,
                padding: "9px 12px",
                color: "#9fb2d3",
                fontSize: 9,
              }}
            >
              LOCAL DEMO UNLOCK
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
